<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">解决方案</div>
        <div class="item_small">-TOTAL SOLUTION-</div>
      </div>
      <div class="gary_text">{{ groupName }}</div>
      <div class="programmeEdit_content row-column acea-row row-center-wrapper">
        <ul class="info_ul row-column acea-row row-center-wrapper">
          <li class="info_li">
            高度成熟的技术加上长期稳定运营的性能，可以通过RS485进行通讯，有效地对后端设备的运行状态进行管理
          </li>
          <li class="info_li">
           产品具有欠压、过压、过流、漏电等功能，大大地提高设备的在线率，特别是对临时因外围环境影响而造成跳闸断电，具备自恢复功能，减少用/1后期维护成本
          </li>
          <li class="info_li">
           方案简单。设备集成高度，无需专业人员，维护难度小。可根据项目的用电情况选择不同电流参数
          </li>
          <li class="info_li_img">
            <img
              class="img"
              src="@/assets/programme/single_content_bg1.png"
              alt=""
            />
          </li>
          <li class="info_li_img">
            <applicationScene :dataList="dataList"></applicationScene>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import applicationScene from "@/components/programme/applicationScene";
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/programme/programmebg1.png"),
      groupName: "单相重合闸系列", //产品类型名称
      dataList: [
        {
          img: require("@/assets/programme/single_item_image3.png"),
        },
        {
          img: require("@/assets/programme/single_item_image4.png"),
        },
        {
          img: require("@/assets/programme/single_item_image1.png"),
        },
        {
          img: require("@/assets/programme/single_item_image2.png"),
        },
      ],
    };
  },
  watch: {},
  components: {
    applicationScene: applicationScene,
  },
  mounted: function () {},
};
</script>
<style scoped>
.content_box {
  width: 100%;
  background-color: #f3f3f3;
}
.content_box .info_ul .info_li {
  margin-bottom: 60px;
  color: #333333;
  font-size: 20px;
  width: 60%;
}
.content_box .info_ul .info_li_img {
  margin-bottom: 60px;
  color: #333333;
  font-size: 20px;
  width: 60%;
  list-style: none;
}
.content_box .info_ul .info_li_img .img {
  width: 100%;
  height: 100%;
  margin: 30px 0px;
}
.content_box .info_ul .info_li_img .img_two {
  width: 100%;
  height: 100%;
  margin: 30px 0px;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .programmeEdit_content {
  padding: 20px 0px;
}
/* 关于我们 begin */
.gary_text {
  font-size: 24px;
  color: #555555;
  margin: 40px 0px;
  margin-right: auto;
  padding-left: 21%;
}
/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
@media screen and (max-width: 850px) {
  .content_box .info_ul .info_li {
    width: 95%;
  }
  .content_box .info_ul .info_li_img {
    width: 95%;
  }
  .gary_text {
    padding-left: 10%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/programme/single.vue